<template>
  <div style="height: 100%;">
    <div class="logo-wrapper" :style="{height: innerWidth > 991 ? '69px' : '82.5px'}">
      <Logo v-if="innerWidth > 991"/>
      
        <img class="img-fluid logo-icon" :src="companyLogo" alt="Company Logo" v-if="innerWidth <= 991 && companyLogo" />
        <div class="logo-icon" v-if="innerWidth <= 991 && !companyLogo">
          {{ companyName[0].toUpperCase() }}
        </div>
        <span class="company-name" v-if="innerWidth <= 991" style=" ">{{ companyName }}</span>
      
      <div class="toggle-sidebar" @click="toggle_sidebar" id="toggle-sidebar" v-if="isMobile">
        <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/Menu/closesidebar.svg" alt="Menu Icon"  v-if="togglesidebar" />
        <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/Menu/opensidebar.svg" alt="Menu Icon Active" v-if="!togglesidebar"/>
      </div>
      <!-- <b-tooltip target="toggle-sidebar" triggers="hover" placement="right" custom-class="sidebar-tooltip">
        <span>{{ togglesidebar ? $t('lbl_EMPBE_CloseSidebar') : $t('lbl_EMPBE_OpenSidebar') }}</span>
      </b-tooltip> -->
    </div>

    <div class="logo-icon-wrapper" style="height: 82.5px;"> 
      <router-link to="/" custom v-slot="{ navigate }">
        <a href="https://www.chinaplasonline.com/eMarketplace/simp" @click="navigate($event)">
        <img
          class="img-fluid"
          src="../../assets/images/logo/EMP-logo.png"
          alt=""
      />
      </a>
      </router-link>

    </div>
    <Nav style="height:calc(100% - 100px)"/>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Logo from './logo.vue';
import Nav from './nav.vue';
import { CompanyInfoService } from '@/_services/CompanyInfo.Service';
import { adService } from '@/_services/ad.js';
import { InquiryFormService } from '@/_services/InquiryForm.service.js';
import { totalFromGetUnreadNumRow } from '@/_helpers/salesLeadUnreadTotal';
export default {
  name: 'Sidebar',
  components: {
    Logo,
    Nav,
  },
  data() {
    return {
      companyLogo: '',
      innerWidth: window.innerWidth,
      companyid: this.$store.state.authentication.user.empCompanyId,
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.getCompanyLogo();
    this.refreshAdMenuBadge();
    this.GetUnreadNum();
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      isMobile: (state) => state.menu.isMobile,
    }),
    langid() {
      return localStorage.getItem("currentLangId")
    },
    companyName() {
      switch (this.langid) {
        case '950':
          return this.$store.state.authentication.user.companyNameTc;
        case '936':
          return this.$store.state.authentication.user.companyNameSc;
        case '1252':
          return this.$store.state.authentication.user.companyNameEn;
      }
    }
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch('menu/opensidebar');
      this.$store.state.menu.activeoverlay = false;
    },
    LogoPath(){
      const locale =
        this.langid == "936" ? "sc" : this.langid == "950" ? "tc" : "en";
      const logoEndPoint = `/EMP_logos_${locale}.png?x-oss-process=image/format,webp`;

      return "https://cdn.adsalecdn.com/EMP/2-0/images" + logoEndPoint;
    },
    getCompanyLogo(){
      // 管理员后台不展示供应商公司 Logo，无需请求
      if (this.$store.state.authentication?.user?.userType === 'ADMIN') {
        return;
      }
      if (!this.companyid) {
        return;
      }
      CompanyInfoService.GetCompanyLogo(this.companyid).then(response => {
        this.companyLogo = response.data;
      });
    },    handleResize() {
      this.innerWidth = window.innerWidth;
    },
    refreshAdMenuBadge() {
      adService.refreshAdMenuBadge(this.companyid, this.$store);
    },
    GetUnreadNum(){
      InquiryFormService.GetUnreadNum(this.companyid).then(res => {
        const first = res && res.length ? res[0] : {};
        const totalUnread = totalFromGetUnreadNumRow(first);
        this.$store.dispatch('unread/setUnread', { unread: totalUnread, type: 'salesLead' });
      });
    }
  },
};
</script>
<style>
.page-wrapper.compact-sidebar .logo-icon-wrapper{
  padding: 24px 10px !important;
}
@media screen and (max-width: 991.98px) {
  .logo-wrapper{
    padding: 16px 8px!important;
  }
  .logo-icon{
    border-radius: 50%; 
    border: 1px solid rgba(0, 0, 0, 0.05); 
    width: 48px; 
    height: 48px; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    font-size: 16px; 
    font-weight: 700; 
    font-family: Roboto;
    background-color: lightgray;
  }
  .company-name{
    font-size: 14px; 
    font-weight: 700; 
    font-family: Roboto;
    margin-left: 8px;
  }
}
</style>